export enum DISCLAIMER_MODAL_NAME {
  SAFE_HARBOR = 'safeHarborDisclaimer',
  HEALOW_BOOKING = 'healowBookingDisclaimer',
}
